const PageContentContainer = ({children}: {children: React.ReactNode}) => {
    return (
        <div className="z-10 col-span-11 flex h-full flex-col gap-10 overflow-hidden rounded-l-[60px] bg-cream-10 py-10 px-24">
            {children}
        </div>
    )
}

export default PageContentContainer
